import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { materialPropType } from '@/components/consumer/PDP/PDPTypes';
import Currency from 'components/consumer/Currency';
import Checkbox from 'components/consumer/Checkbox';
import CtaButton from 'components/essentials/Cta/CtaButton';
import PDPAlertBar from '../PDPAlertBar';
import usePdpEditOrderErrorMessage from '../state/pdpEditOrderErrorMessage/usePdpEditOrderErrorMessage';
const PDPFabricUpChargeModal = loadable(() => import('../PDPFabricUpChargeModal'));
const PDPCompleteOrderUI = t0 => {
  const $ = _c(32);
  const {
    loading,
    orderId,
    cartItem,
    isChecked,
    showModal,
    orderInfo,
    updateOrder,
    setIsChecked,
    setShowModal,
    selectedMaterial,
    onCompletedOrderClick,
    orderUpChargeSummaryData
  } = t0;
  const editOrderErrorMessage = usePdpEditOrderErrorMessage();
  const additionalCost = selectedMaterial?.additionalCost;
  let t1;
  if ($[0] !== additionalCost) {
    t1 = additionalCost > 0 && <PDPAlertBar type="info">Your selected material has an additional charge of{" "}<Currency>{additionalCost}</Currency></PDPAlertBar>;
    $[0] = additionalCost;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isChecked || $[3] !== setIsChecked) {
    t2 = () => {
      setIsChecked(!isChecked);
    };
    $[2] = isChecked;
    $[3] = setIsChecked;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isChecked || $[6] !== t2) {
    t3 = <div className="mx-0 my-6 [&_label]:text-sm"><Checkbox onChange={t2} checked={isChecked} size="sm">I understand product options will be finalized and I cannot make any further changes</Checkbox></div>;
    $[5] = isChecked;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !isChecked || loading;
  let t5;
  if ($[8] !== loading || $[9] !== onCompletedOrderClick || $[10] !== t4) {
    t5 = <CtaButton disabled={t4} data-xc="edit-order-button" onClick={onCompletedOrderClick} styling="solid-button" color="black" block={true} isLoading={loading}>Complete order</CtaButton>;
    $[8] = loading;
    $[9] = onCompletedOrderClick;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== editOrderErrorMessage) {
    t6 = editOrderErrorMessage && <div className="text-sm font-bold text-red mx-0 my-1 text-center">{editOrderErrorMessage}</div>;
    $[12] = editOrderErrorMessage;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="PDPCompleteOrderUI__complete-order">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== cartItem || $[18] !== editOrderErrorMessage || $[19] !== orderId || $[20] !== orderInfo || $[21] !== orderUpChargeSummaryData || $[22] !== selectedMaterial || $[23] !== setShowModal || $[24] !== showModal || $[25] !== updateOrder) {
    t8 = showModal && orderId && cartItem && <PDPFabricUpChargeModal orderId={orderId} cartItem={cartItem} orderInfo={orderInfo} updateOrder={updateOrder} onClose={() => setShowModal(false)} selectedMaterial={selectedMaterial} editOrderErrorMessage={editOrderErrorMessage} orderUpChargeSummaryData={orderUpChargeSummaryData} />;
    $[17] = cartItem;
    $[18] = editOrderErrorMessage;
    $[19] = orderId;
    $[20] = orderInfo;
    $[21] = orderUpChargeSummaryData;
    $[22] = selectedMaterial;
    $[23] = setShowModal;
    $[24] = showModal;
    $[25] = updateOrder;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t1 || $[28] !== t3 || $[29] !== t7 || $[30] !== t8) {
    t9 = <div className="PDPCompleteOrderUI">{t1}{t3}{t7}{t8}</div>;
    $[27] = t1;
    $[28] = t3;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
PDPCompleteOrderUI.propTypes = {
  loading: PropTypes.bool,
  orderId: PropTypes.string,
  cartItem: PropTypes.shape({
    slug: PropTypes.string
  }),
  orderInfo: PropTypes.shape({
    shipping: PropTypes.shape({
      address_first_name: PropTypes.string,
      address_last_name: PropTypes.string
    }),
    customer: PropTypes.shape({
      customer_email: PropTypes.string
    })
  }),
  showModal: PropTypes.bool,
  isChecked: PropTypes.bool,
  setShowModal: PropTypes.func,
  setIsChecked: PropTypes.func,
  updateOrder: PropTypes.func,
  selectedMaterial: materialPropType,
  onCompletedOrderClick: PropTypes.func,
  orderUpChargeSummaryData: PropTypes.object
};
export default PDPCompleteOrderUI;